import { connect } from "react-redux";
import * as thunkActions from "../actions/thunks";
import { closeModalAsThunk, openAddressModalAsThunk } from "../../../Header/actions/thunks";
import {
  setUpdateTransactionModalOpen,
  setImportModalOpen,
  setStatusLoading,
} from "../../../Header/actions/creators";
import { setRefStatus } from "../actions/creators";
import ImportListingDetailsModal from "./ImportListingDetailsModal";

const mapStateToProps = (state) => ({
  accountPropertyTypes: state.tdpDetailsReducer.meta.accountPropertyTypes,
  listingDetailsData: state.tdpDetailsReducer.listingDetails,
  uuid: state.tdpDetailsReducer.uuid,
  photosAvailable: state.tdpDetailsReducer.listingImgs.length,
  propertyDetails: state.tdpDetailsReducer.propertyDetails,
  modalOpen: state.tdpDetailsReducer.isImportModalOpen,
  status: state.tdpDetailsReducer.transactionDetails.status,
  preStatus: state.tdpDetailsReducer.preStatus,
});

const mapDispatchToProps = (dispatch) => ({
  onGetAllDetailsAsThunk: (uuid) => dispatch(thunkActions.getAllDetailsAsThunk(uuid)),
  onGetPropertyTypesAsThunk: (uuid) => dispatch(thunkActions.getPropertyTypesAsThunk(uuid)),
  closeModalAsThunk: (preStatus) => dispatch(closeModalAsThunk(preStatus)),
  setToggleModal: (isOpen, updatedStatus, preStatus) =>
    dispatch(openAddressModalAsThunk(isOpen, updatedStatus, preStatus)),
  openUpdateTransactionModal: (isOpen, mlsListingData) =>
    dispatch(setUpdateTransactionModalOpen(isOpen, mlsListingData)),
  closeImportModal: () => dispatch(setImportModalOpen(false, null)),
  revertStatus: (_uuid, status) => {
    dispatch(setRefStatus(status));
    dispatch(setStatusLoading(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportListingDetailsModal);
